module.exports = __webpack_public_path__ + "media/index/fr-art-9bd2a451.png";